import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/return-units-from-scraps`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const returnUnitsFromScraps = {
  post: apiPathFunc(pathBase),
};
